import { ErrorBoundary } from '@enter/core';
import { AcceptInvitation, Expired, Logout, Main, NotFound, Redirect, Version } from 'pages';
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { PrivateRoute } from './private-route';

export function AppRouter(): React.ReactElement {
    return (
        <Router>
            <Switch>
                <Route path="/accept_invitation" component={AcceptInvitation} />
                <Route path="/logout" component={Logout} />
                <Route path="/expired" component={Expired} />
                <Route path="/redirect" component={Redirect} />
                <Route path="/version" component={Version} />
                <Route path="/404" component={NotFound} />
                <ErrorBoundary>
                    <PrivateRoute path="/" component={Main} />
                </ErrorBoundary>
            </Switch>
        </Router>
    );
}
